import React, { useState, useEffect, use } from 'react'
import {
  // Table,
  Form,
  Pagination,
  Button,
  Modal,
  Col,
  Container,
  Row,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Book, CreditCard } from 'react-bootstrap-icons'
import { Eye, PencilSquare, Trash } from 'react-bootstrap-icons'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { FaSyncAlt, FaUserEdit } from 'react-icons/fa'
import { Typeahead } from 'react-bootstrap-typeahead'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'

const DataTable = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '300px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])
  const [selectedSession, setSelectedSession] = useState('')
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [baseAmount, setBaseAmount] = useState('')
  const [loading, setLoading] = useState(false)
  const [allFees, setAllFees] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState('')
  const [selectedCourseOption, setSelectedCourseOption] = useState([])
  const [isCourseDisabled, setIsCourseDisabled] = useState(false)
  const [isFrequencyDisabled, setIsFrequencyDisabled] = useState(false)

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('All course:', res.data.data)
      setCourses(res.data.data)
      setAllCourses(res.data.data)
    })
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllFees()
      .then((res) => {
        setAllFees(res.data.data)
        setData(res.data.data) // This is your filtered data
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  const [newFee, setNewFee] = useState({
    fee_name: '',
    amount: '',
    // course_id: '',
    fee_frequency: '',
    session: '',
    fee_name_custom: '',
  })

  // const isManualAmount = (feeName = newFee.fee_name) => {
  //   return ['registration', 'admission', 'others'].includes(
  //     feeName?.toLowerCase(),
  //   )
  // }

  const isManualAmount = () => {
  return ['others', 'registration', 'admission','exam_fees'].includes(newFee.fee_name?.toLowerCase())
}

  const getSessionOptions = () => {
    const currentYear = new Date().getFullYear()
    const sessions = []

    for (let i = 0; i < 1; i++) {
      let session = `${currentYear + i}-${(currentYear + i + 1)
        .toString()
        .slice(-2)}`
      sessions.push(session)
    }
    return sessions
  }

  const handleCourseFieldChange = (e) => {
    const courseId = e.target.value
    setSelectedData((prev) => ({ ...prev, course: courseId }))
    handleSelect({ course: courseId })
    console.log('HANDLESELECT:', handleSelect)
  }

  const handleCourseChange = (e) => {
    const selectedId = e.target.value
    const selectedCourse = courses.find(
      (course) => course.id.toString() === selectedId,
    )

    if (selectedCourse) {
      setSelectedNewCourse(selectedCourse.id)
      setBaseAmount(selectedCourse.fee)

      // Only set the fee if the selected type is "course"
      if (newFee.fee_name === 'course' && newFee.fee_frequency) {
        const amount = calculateAmount(selectedCourse.fee, newFee.fee_frequency)
        setNewFee((prev) => ({
          ...prev,
          amount,
        }))
      }
    }
  }

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)

  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  const calculateAmount = (base, frequency) => {
    const numericBase = parseFloat(base)
    if (isNaN(numericBase)) return ''

    const selectedCourse = courses.find(
      (course) => course.id === selectedNewCourse,
    )
    const duration = selectedCourse?.duration

    if (frequency === 'monthly' && duration) {
      return (numericBase / duration).toFixed(2)
    }

    return numericBase.toFixed(2)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target

    if (name === 'fee_name') {
      const feeName = value.toLowerCase()

      // Reset all fee-related fields when fee_name is 'course'
      if (feeName === 'course') {
        setNewFee({
          fee_name: 'course',
          amount: '',
          fee_frequency: '',
          session: '',
          fee_name_custom: '',
        })
        setSelectedNewCourse('')
        setIsFrequencyDisabled(false)
        setIsCourseDisabled(false)
        return
      }

      const isAdmissionOrRegistration = ['admission', 'registration'].includes(
        feeName,
      )

          const isExamFees = feeName === 'exam_fees'

      // const shouldDisableCourse = feeName === 'others'

      setNewFee((prev) => ({
        ...prev,
        fee_name: value,
        fee_frequency: isAdmissionOrRegistration || isExamFees ? 'one-time' : '',
          amount: isExamFees ? '' : prev.amount
      }))

      setIsFrequencyDisabled(isAdmissionOrRegistration || isExamFees)
      // setIsCourseDisabled(shouldDisableCourse)
      setSelectedNewCourse('')
      return
    }

    // Block fee_frequency changes if disabled
    if (name === 'fee_frequency' && isFrequencyDisabled) return

    if (name === 'amount' && isManualAmount()) {
      setNewFee((prev) => ({
        ...prev,
        amount: value,
      }))
      return
    }

    // Update amount automatically based on frequency and course
    let updatedAmount = newFee.amount
    let updatedFrequency =
      name === 'fee_frequency' ? value : newFee.fee_frequency

    if (!isManualAmount()) {
      const selectedCourse = courses.find(
        (course) => course.id === selectedNewCourse,
      )
      const duration = selectedCourse?.duration || 1
      const numericBase = parseFloat(baseAmount)

      if (!isNaN(numericBase)) {
        updatedAmount =
          updatedFrequency === 'monthly'
            ? (numericBase / duration).toFixed(2)
            : numericBase.toFixed(2)
      }
    }

    setNewFee((prev) => ({
      ...prev,
      [name]: value,
      amount: updatedAmount,
    }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      let feeName = newFee.fee_name

      if (feeName === 'others') {
        feeName = newFee.fee_name_custom?.trim().toLowerCase() || 'others'
      }

      const { fee_name_custom, ...cleanFee } = newFee
      const feeData = {
        ...cleanFee,
        object_id: selectedNewCourse,
        fee_name: feeName,
      }

      const response = await ApiEndpoints.addFee(feeData)
      toast.success(response.data.message)

      // Reset form
      setNewFee({
        fee_name: '',
        amount: '',
        fee_frequency: '',
        session: '',
        fee_name_custom: '',
      })
      setSelectedNewCourse('')
      setIsFrequencyDisabled(false)
      setIsCourseDisabled(false)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something went wrong.')
    } finally {
      setLoading(false)
    }
  }

  const [allCourses, setAllCourses] = useState([])

  const [selectedData, setSelectedData] = useState({ course: '' })

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }
  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allFees
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.object_id?.toString() === course.toString(),
      )
    }
    setData(updatedData)
  }

  useEffect(() => {
    // fetchFilteredData(selectedData)
    fetchFilteredData({ course: selectedCourseId })
  }, [])
  useEffect(() => {
    if (selectedCourseId && courses.length > 0) {
      const selected = courses.find((c) => c.id === Number(selectedCourseId))
      if (selected) {
        setSelectedCourseOption([selected])
      }
    }
  }, [courses, selectedCourseId])

  const handleRefresh = async () => {
    try {
      setLoading(true)
      const response = await ApiEndpoints.getAllFees()
      setAllFees(response.data.data)
      setData(response.data.data)
      setSelectedCourseId('')
      setSelectedCourseOption([])
    } catch (error) {
      toast.error('Failed to refresh data.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        {/* Desktop View */}
        {/* <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white"> */}
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>Fee Structure</h2>
          <Button
            variant="light"
            className="fw-bold"
            // onClick={() => setShowModal(true)}
             onClick={() => {
            setShowModal(true);
            // Reset form when opening modal
            setNewFee({
              fee_name: '',
              amount: '',
              fee_frequency: '',
              session: '',
              fee_name_custom: '',
            });
            setSelectedNewCourse('');
            setIsFrequencyDisabled(false);
            setIsCourseDisabled(false);
          }}
          >
            <CreditCard size={18} className="me-2" />
            Add New Fee Structure
          </Button>
          {/* </div> */}
          {/* Mobile View */}
          {/* <div className="bg-secondary p-3 rounded d-flex d-md-none flex-column align-items-center text-white "> */}
          {/* <div className="bg-secondary rounded d-flex d-md-none d-flex justify-content-start align-items-center text-white">
          <h3 className="m-0 mb-3">Fee Management</h3>
          <Button
            variant="light"
            className="fw-bold w-100"
            onClick={() => setShowModal(true)}
          >
            <CreditCard size={16} className="me-2" />
            <span>Add Fee</span>
          </Button>
        </div> */}
        </div>
      </div>
      {/* <div className="mt-4"> */}
      <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Course</Form.Label>
            {/* <Form.Select
              value={selectedNewCourse}
              onChange={handleCourseFieldChange}
            >
              <option value="">Select Course</option>
              {allCourses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select> */}
            {/* <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseFieldChange({ target: { value: course.id } })
                } else {
                  handleCourseFieldChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedNewCourse.course),
              )}
            /> */}
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  setSelectedCourseId(course.id) // Update course ID
                  setSelectedCourseOption([course]) // Update selected object
                  handleSelect({ course: course.id })
                } else {
                  setSelectedCourseId('')
                  setSelectedCourseOption([])
                  handleSelect({ course: '' })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={selectedCourseOption}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label className="fw-bold d-md-none text-start">
              Session
            </Form.Label>
            <Form.Select
              // style={{ minWidth: '450px' }}
              value={selectedSession}
              onChange={(e) => setSelectedSession(e.target.value)}
            >
              <option value="">Filter by Session</option>
              {getSessionOptions().map((session, index) => (
                <option key={index} value={session}>
                  {session}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col className="d-flex justify-content-md-end justify-content-start">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="mb-3 me-3 py-2" // Added padding for better touch target
            style={{ minWidth: '100px' }} // Ensures consistent width
          >
            <div className="d-flex align-items-center justify-content-center gap-2">
              <FaSyncAlt size={18} />{' '}
              {/* Slightly smaller icon for better proportion */}
              Refresh
            </div>
          </Button>
        </Col>
      </Row>

      {/* <div className="d-md-none">
        <Button
          onClick={handleRefresh}
          title="Refresh"
          variant="primary"
          className="position-fixed bottom-0 end-0 m-3 rounded-circle shadow"
          style={{ width: '60px', height: '60px', zIndex: 999 }}
        >
          <FaSyncAlt size={24} />
        </Button>
      </div> */}
      {/* </div> */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3 mt-4">
        {/* <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4"> */}
        <p className="text-black m-0">Total Records: {filteredData.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
        </Form.Select>
      </div>
      {/* <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white d-none d-md-table-header-group">
          <tr className=" rounded">
            <th>Fee Name</th>
            <th>Course Name</th>
            <th>Amount</th>
            <th>Fee Frequency</th>
            <th>Action</th>
          </tr>
        </Thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <tr className="d-none d-md-table-row">
                    <td>
                      {item.fee_name
                        ? item.fee_name.charAt(0).toUpperCase() +
                          item.fee_name.slice(1)
                        : 'N/A'}
                    </td>
                    <td>
                      {' '}
                      {courses.find((course) => course.id === item.object_id)
                        ?.name || 'N/A'}
                    </td>{' '}
                    <td>₹ {item.amount}</td>
                    <td>
                      {item.fee_frequency
                        ? item.fee_frequency.charAt(0).toUpperCase() +
                          item.fee_frequency.slice(1)
                        : 'N/A'}
                    </td>
                    <td className="text-center">
                      <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                        <Button variant="info" size="sm">
                          <Eye />
                        </Button>

                      </div>
                    </td>
                  </tr>

                  <tr className="d-table-row d-md-none">
                    <td colSpan="5">
                      <div className="card-body">
                        <p className="d-flex justify-content-between d-flex algin-items-center">
                          <strong>Fee Name</strong>
                          <span className="justify-content-start d-flex align-items-center">
                            {item.fee_name?.charAt(0).toUpperCase() +
                              item.fee_name?.slice(1) || 'N/A'}
                          </span>
                        </p>
                        <p className="d-flex justify-content-between d-flex algin-items-center">
                          <strong>Course Name</strong>{' '}
                          {courses.find(
                            (course) => course.id === item.object_id,
                          )?.name || 'N/A'}
                        </p>
                        <p>
                          <strong>Amount</strong> ₹ {item.amount}
                        </p>
                        <p>
                          <strong>Fee Frequency</strong>{' '}
                          {item.fee_frequency?.charAt(0).toUpperCase() +
                            item.fee_frequency?.slice(1) || 'N/A'}
                        </p>
                        <div className="d-flex gap-2">
                          <Button variant="info" size="sm">
                            <Eye />
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              )
            })
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table> */}

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr className=" rounded">
            <Th>Fee Name</Th>
            <Th>Course Name</Th>
            <Th>Amount</Th>
            <Th>Fee Frequency</Th>
            {/* <Th>Action</Th> */}
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index}>
                <Td>
                  {item.fee_name
                    ? item.fee_name.charAt(0).toUpperCase() +
                      item.fee_name.slice(1)
                    : 'N/A'}
                </Td>
                <Td>
                  {courses.find((course) => course.id === item.object_id)
                    ?.name || 'N/A'}
                </Td>
                <Td>₹ {item.amount}</Td>
                <Td>
                  {item.fee_frequency
                    ? item.fee_frequency.charAt(0).toUpperCase() +
                      item.fee_frequency.slice(1)
                    : 'N/A'}
                </Td>
                {/* <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                    <Button variant="info" size="sm">
                      <Eye />
                    </Button>
                  </div>
                </Td> */}
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan="15" className="text-center">
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <div className="d-flex justify-content-center justify-content-md-end align-items-center mt-3">
        <Pagination size="sm">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Modal for Adding Fee */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="bg-secondary">
          <Modal.Title className="text-white">Add Fee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3 text-start">
              <Form.Label>Fee Name</Form.Label>
              <Form.Select
                name="fee_name"
                value={newFee.fee_name}
                onChange={handleInputChange}
              >
                <option value="">Select Fee Name</option>
                <option value="registration">Registration</option>
                <option value="admission">Admission</option>
                <option value="course">Course</option>
                <option value="exam_fees">Exam Fees</option>
                <option value="others">Others</option>             
              </Form.Select>
            </Form.Group>

            {newFee.fee_name === 'others' && (
              <Form.Group className="mb-3 text-start">
                <Form.Label>Custom Fee Name</Form.Label>
                <Form.Control
                  type="text"
                  name="fee_name_custom"
                  placeholder="Enter fee name (e.g. Late fees)"
                  value={newFee.fee_name_custom}
                  onChange={handleInputChange}
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Course *</Form.Label>
              <Form.Select
                name="course_id"
                value={selectedNewCourse}
                onChange={handleCourseChange}
                disabled={isCourseDisabled}
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Fee Frequency *</Form.Label>
              <Form.Select
                name="fee_frequency"
                value={newFee.fee_frequency}
                onChange={handleInputChange}
                required
                disabled={isFrequencyDisabled}
              >
                <option value="">Select</option>
                <option value="monthly">Monthly</option>
                <option value="one-time">One Time</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={newFee.amount}
                onChange={handleInputChange}
                disabled={!isManualAmount()}
                placeholder={
                  isManualAmount() ? 'Enter amount' : 'Auto-calculated'
                }
                required
              />
            </Form.Group>
            {/* <Form.Group className="mb-3">
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={newFee.amount}
                disabled
              />
            </Form.Group> */}
            <Form.Group className="mb-3">
              <Form.Label>Session</Form.Label>
              <Form.Select
                name="session"
                value={newFee.session || ''}
                onChange={handleInputChange}
              >
                <option value="">Select Session</option>
                {getSessionOptions().map((session, index) => (
                  <option key={index} value={session}>
                    {session}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="success" type="submit">
                Add Fee
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default DataTable
